(() => {
  const start = (scope) => {
    const catalog = scope.querySelector('.catalog-inquiries');
    if (!catalog || catalog.dataset.browseReady) return;
    const tools = catalog.querySelector('[data-catalog-tools]');
    const input = catalog.querySelector('[data-catalog-search]');
    const category = catalog.querySelector('[data-catalog-category]');
    const status = catalog.querySelector('[data-catalog-count]');
    const reset = catalog.querySelector('[data-catalog-reset]');
    if (!tools || !input || !category || !status || !reset) return;
    catalog.dataset.browseReady = 'true';
    const groups = [...catalog.querySelectorAll('.catalog-inquiry-group')];
    const cards = [...catalog.querySelectorAll('[data-inquiry-handle]')].map(card => ({card, group: card.closest('.catalog-inquiry-group'), text: card.textContent.toLowerCase()}));
    const empty = catalog.querySelector('[data-catalog-empty]');
    const update = () => {
      const words = input.value.trim().toLowerCase().split(/\s+/).filter(Boolean);
      let count = 0;
      cards.forEach(item => {
        const match = (!category.value || item.group.id === category.value) && words.every(word => item.text.includes(word));
        item.card.hidden = !match;
        if (match) count += 1;
      });
      groups.forEach(group => { group.hidden = !cards.some(item => item.group === group && !item.card.hidden); });
      status.textContent = status.dataset.countTemplate.replace('[count]', String(count));
      reset.hidden = !input.value && !category.value;
      if (empty) empty.hidden = count !== 0;
    };
    const showFirst = () => {
      const first = groups.find(group => !group.hidden) || empty;
      if (first) first.scrollIntoView({block: 'start', behavior: 'instant'});
    };
    input.addEventListener('input', () => { update(); showFirst(); });
    category.addEventListener('change', () => {
      update();
      showFirst();
    });
    reset.addEventListener('click', () => { input.value = ''; category.value = ''; update(); showFirst(); input.focus({preventScroll: true}); });
    const revealHash = () => {
      const id = location.hash.slice(1);
      if (!id) return;
      if (id === 'CatalogSearch') { input.focus({preventScroll: true}); return; }
      const target = document.getElementById(id);
      if (target && catalog.contains(target) && target.closest('.catalog-inquiry-group')) {
        input.value = ''; category.value = ''; update();
        target.scrollIntoView({block: 'start', behavior: 'instant'});
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({preventScroll: true});
      }
    };
    window.addEventListener('hashchange', revealHash);
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link) return;
      const destination = new URL(link.href, location.href);
      if (destination.origin === location.origin && destination.pathname === location.pathname && destination.search === location.search && destination.hash && destination.hash === location.hash) revealHash();
    });
    catalog.querySelector('.catalog-inquiry-nav').addEventListener('click', () => { input.value = ''; category.value = ''; update(); });
    tools.hidden = false;
    catalog.classList.add('is-enhanced');
    update();
    revealHash();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document), {once: true});
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
